export interface HeroSlide {
  id: number;
  image: string;
  tag: string;
  title: string;
  subtitle: string;
  episodeId: number;
}

export const heroSlides: HeroSlide[] = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=cinematic%20wide%20dark%20navy%20night%20scene%20of%20an%20ancient%20japanese%20wooden%20mansion%20under%20a%20huge%20pale%20full%20moon%2C%20drifting%20mist%2C%20deep%20blue%20and%20black%20tones%20with%20subtle%20gold%20moonlight%20accents%2C%20mysterious%20dramatic%20film%20poster%20atmosphere%2C%20highly%20detailed%20cinematic%20lighting&width=1920&height=1080&seq=wuyan-hero-01&orientation=landscape",
    tag: "全网热播中",
    title: "无颜之月",
    subtitle: "被抹去的名字，终将在满月之下被重新念起",
    episodeId: 1,
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=cinematic%20wide%20dark%20navy%20atmospheric%20scene%20of%20a%20lone%20lantern%20glowing%20in%20a%20misty%20old%20courtyard%20at%20night%2C%20deep%20black%20blue%20gradient%2C%20warm%20gold%20light%20source%2C%20mysterious%20emotional%20mood%2C%20film%20poster%20style%2C%20highly%20detailed%20cinematic%20composition&width=1920&height=1080&seq=wuyan-hero-02&orientation=landscape",
    tag: "高能名场面",
    title: "满月之约",
    subtitle: "数十年的等待，只为这一夜兑现",
    episodeId: 8,
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=cinematic%20wide%20dark%20navy%20abstract%20scene%20of%20sinking%20white%20fabric%20in%20deep%20cold%20blue%20water%20with%20rippling%20light%20and%20faint%20gold%20particles%2C%20dreamlike%20mysterious%20film%20poster%20atmosphere%2C%20muted%20elegant%20tones%2C%20highly%20detailed%20cinematic%20lighting&width=1920&height=1080&seq=wuyan-hero-03&orientation=landscape",
    tag: "悬念升级",
    title: "沉入深蓝",
    subtitle: "有些记忆，沉得越深越清晰",
    episodeId: 6,
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=cinematic%20wide%20dark%20navy%20dawn%20scene%20over%20an%20old%20mountain%20estate%20with%20first%20warm%20light%20breaking%20through%20cold%20blue%20night%20mist%2C%20soft%20gold%20sunrise%20glow%2C%20hopeful%20emotional%20finale%20mood%2C%20film%20poster%20style%2C%20highly%20detailed%20cinematic%20composition&width=1920&height=1080&seq=wuyan-hero-04&orientation=landscape",
    tag: "大结局已上线",
    title: "还给你的名字",
    subtitle: "晨光洒进别院，一切终于有了归宿",
    episodeId: 12,
  },
];